module.exports = __webpack_public_path__ + "img/offline.2412c99a.jpeg";